import PushBackIcon from "../../../assets/icons/PushBackIcon";
import { Card, Header } from "./styles";
import LogoZaivu from "../../../assets/Logo-Zaivu.svg";

/**
 * @param {{ pushBack: () => void, title: string | undefined}} props
 * @prop {() => void} pushBack
 * @prop {string} title
 * @return {JSX.Element}
 */
export function HeaderCard({ pushBack, title }) {
  return (
    <Card id="header-card">
      <Header>
        <div style={{ display: "flex", alignItems: "center" }}>
          <button
            onClick={pushBack}
            style={{
              border: "none",
              background: "none",
              marginTop: "5px",
            }}
          >
            <PushBackIcon
              width={30}
              height={30}
              onClick={() => {}}
              style={{}}
              stroke="#118052"
            />
          </button>
          <span>{title}</span>
        </div>
        <img alt="logo-zaivu" src={LogoZaivu} />
      </Header>
    </Card>
  );
}
